(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-mic-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mic-slide]'));
    if (!track || slides.length < 2) return;

    var autoplayMs = parseInt(root.dataset.autoplay, 10) || 4000;
    var transitionMs = parseInt(root.dataset.transition, 10) || 700;
    var visibleDesktop = parseInt(root.dataset.visibleDesktop, 10) || 4;
    var visibleMobile = parseInt(root.dataset.visibleMobile, 10) || 2;

    var timer = null;
    var isAnimating = false;
    var slideWidth = 0;

    function getVisibleCount() {
      return window.innerWidth <= 749 ? visibleMobile : visibleDesktop;
    }

    function layout() {
      var visible = getVisibleCount();
      var containerWidth = root.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      slideWidth = (containerWidth - gap * (visible - 1)) / visible;

      slides.forEach(function (slide) {
        slide.style.width = slideWidth + 'px';
      });

      track.style.transition = 'none';
      track.style.transform = 'translateX(0)';
      // force reflow so the transition-none takes effect before re-enabling
      void track.offsetHeight;
    }

    function goNext() {
      if (isAnimating) return;
      isAnimating = true;

      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      track.style.transition = 'transform ' + transitionMs + 'ms ease';
      track.style.transform = 'translateX(-' + (slideWidth + gap) + 'px)';

      var onEnd = function () {
        track.removeEventListener('transitionend', onEnd);
        var first = slides.shift();
        track.appendChild(first);
        slides.push(first);

        track.style.transition = 'none';
        track.style.transform = 'translateX(0)';
        void track.offsetHeight;

        isAnimating = false;
      };
      track.addEventListener('transitionend', onEnd);
    }

    function goPrev() {
      if (isAnimating) return;
      isAnimating = true;

      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      var last = slides.pop();
      track.insertBefore(last, track.firstChild);
      slides.unshift(last);

      track.style.transition = 'none';
      track.style.transform = 'translateX(-' + (slideWidth + gap) + 'px)';
      void track.offsetHeight;

      requestAnimationFrame(function () {
        track.style.transition = 'transform ' + transitionMs + 'ms ease';
        track.style.transform = 'translateX(0)';
      });

      var onEnd = function () {
        track.removeEventListener('transitionend', onEnd);
        isAnimating = false;
      };
      track.addEventListener('transitionend', onEnd);
    }

    function startAutoplay() {
      stopAutoplay();
      if (autoplayMs > 0) {
        timer = setInterval(goNext, autoplayMs);
      }
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    var nextBtn = root.querySelector('[data-mic-next]');
    var prevBtn = root.querySelector('[data-mic-prev]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goNext();
        startAutoplay();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goPrev();
        startAutoplay();
      });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(layout, 150);
    });

    layout();
    startAutoplay();
  }

  function initAll() {
    var carousels = document.querySelectorAll('[data-mic-carousel]');
    carousels.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var carousel = event.target.querySelector('[data-mic-carousel]');
    if (carousel) initCarousel(carousel);
  });
})();
